import { render, staticRenderFns } from "./PSDPreviewBadge.vue?vue&type=template&id=19ba5865&scoped=true"
import script from "./PSDPreviewBadge.vue?vue&type=script&lang=js"
export * from "./PSDPreviewBadge.vue?vue&type=script&lang=js"
import style0 from "./PSDPreviewBadge.vue?vue&type=style&index=0&id=19ba5865&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ba5865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ba5865')) {
      api.createRecord('19ba5865', component.options)
    } else {
      api.reload('19ba5865', component.options)
    }
    module.hot.accept("./PSDPreviewBadge.vue?vue&type=template&id=19ba5865&scoped=true", function () {
      api.rerender('19ba5865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/PSDPreviewBadge.vue"
export default component.exports